/**
 * Page identification for analytics and lead routing.
 * Each route should set its own PAGE_CODE.
 *
 * Currently:
 *   - "/"          → CENA  (this lead-gen landing about cost)
 *
 * Future planned routes:
 *   - "/montaz"    → MONTAZ
 *   - "/oszczednosci" → OSZCZEDNOSCI
 */
export const PAGE_CODE = "CENA";
